var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.showed)?_c('el-form-item',{attrs:{"label":_vm.item.label,"prop":`${_vm.item.field}`,"hidden":_vm.item.options.hidden,"rules":[
    {
      required: _vm.item.required || false,
      message: _vm.item.label + '为必填字段',
    },
  ]}},[_c('div',{staticClass:"main"},_vm._l((JSON.parse(_vm.item.val)),function(file,idx){return _c('a',{key:idx,attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.download(file.url, file.name)}}},[_c('div',{staticClass:"file-list-group"},[_c('div',{staticClass:"file-group-cell"},[_c('i',{staticClass:"el-icon-paperclip text-muted"})]),_c('div',{staticClass:"file-group-cell"},[_c('span',{staticClass:"file-title"},[_vm._v(_vm._s(file.name))])])])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }